import React from 'react';
import propTypes from 'prop-types';
import Button from 'tailwind-components/Button';
import { STATE_LIST_CERT } from 'constants/enum';

// initial SBE screen: asks the agent to confirm certification before requesting
export default function SBERequestNotice({
  requestedStates,
  closeModal,
  setAreInstructionsOpen,
  handleSubmit
}) {
  const sbeRows = STATE_LIST_CERT.filter(row =>
    requestedStates.includes(row.state)
  );

  return (
    <>
      <div className='flex flex-col gap-2'>
        <p className='text-base font-semibold m-0'>
          Are you certified? You must be certified with the state exchange in
          order for an appointment to be processed.
        </p>
        <h4 className='text-base font-medium m-0'>
          Requested states requiring certification:
        </h4>
        <div className='flex flex-col gap-1'>
          {sbeRows.map(row => (
            <p key={row.state} className='m-0'>
              - {row.state}
            </p>
          ))}
        </div>
      </div>

      <div className='flex flex-col-reverse lg:flex-row justify-end gap-3 mt-6 w-full'>
        <Button
          className='flex-1'
          variant='danger'
          text='Cancel'
          onClick={closeModal}
        />
        <Button
          className='flex-1'
          variant='secondary'
          text='No, I want to get certified'
          onClick={() => setAreInstructionsOpen(true)}
        />
        <Button
          className='flex-1'
          variant='primaryDarkened'
          text='Yes, proceed with request'
          onClick={() => handleSubmit(requestedStates, true)}
        />
      </div>
    </>
  );
}

SBERequestNotice.propTypes = {
  requestedStates: propTypes.array.isRequired,
  closeModal: propTypes.func.isRequired,
  setAreInstructionsOpen: propTypes.func.isRequired,
  handleSubmit: propTypes.func.isRequired
};
